import { render } from "./TypeSelection.vue?vue&type=template&id=11ddaa3c"
import script from "./TypeSelection.vue?vue&type=script&lang=js"
export * from "./TypeSelection.vue?vue&type=script&lang=js"

import "./TypeSelection.vue?vue&type=style&index=0&id=11ddaa3c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__